module.exports = __webpack_public_path__ + "static/media/21_tn.3a9959ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/21_tn.jpg
// module id = 235
// module chunks = 0